import { render, staticRenderFns } from "./edittuwen.vue?vue&type=template&id=283c5ede&scoped=true"
import script from "./edittuwen.vue?vue&type=script&lang=js"
export * from "./edittuwen.vue?vue&type=script&lang=js"
import style0 from "./edittuwen.vue?vue&type=style&index=0&id=283c5ede&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283c5ede",
  null
  
)

export default component.exports